import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { authorisedClient } from '../apollo/authorisedClient';
import { unauthorisedClient } from '../apollo/unauthorisedClient';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { ACCESS_TOKEN_FROM_ONE_TIME_TOKEN } from '../queries/auth/authTypeDefs';
import { AuthContext } from './AuthContext';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const AuthProvider: React.FC = ({ children }) => {
  const query = useQuery();
  const history = useHistory();
  const [value, setValue, removeValue] = useLocalStorage('authToken');
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(value);
  const authCode = query.get('authCode');
  const REACT_APP_SSO_URL = window.tz_globalConfigs.ssoUrl || '';

  const getAndStoreToken = useCallback(() => {
    unauthorisedClient.mutate({ mutation: ACCESS_TOKEN_FROM_ONE_TIME_TOKEN, variables: { token: authCode } })
      .then(({ data: { tokenFromOneTimeToken } }) => {
        storeToken(tokenFromOneTimeToken);
        setLoading(false);
        history.replace({
          search: '',
        });
      })
      .catch((e) => {
        console.log('Error', e);
        window.location.href = '/';
      });
    // eslint-disable-next-line
  }, [authCode]);

  useEffect(() => {
    const authCode = query.get('authCode');
    if (authCode) {
      authorisedClient.clearStore();
      getAndStoreToken();
    } else if (!token) {
      window.location.href = `${REACT_APP_SSO_URL}?return=${window.location.href}`;
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [authCode]);

  const storeToken = (token: any) => {
    setValue(token);
    setToken(token);
  };

  const removeToken = () => {
    removeValue();
    setToken(null);
  };

  if (loading) {
    return null;
  }

  return (
    <AuthContext.Provider value={{
      token,
      setToken: storeToken,
      removeToken,
    }}>
      {children}
    </AuthContext.Provider>
  );
};
